import React from 'react';
import _ from 'lodash';
import { Theme, createStyles, WithStyles, Tooltip, Typography, withStyles } from '@material-ui/core';
import UserGroupIcon from '../../../assets/svg/UserGroup';

const styles = (theme: Theme) => createStyles({
    groupName: {
        textTransform: 'capitalize',
        fontWeight: theme.typography.fontWeightRegular,
    },
    groupIconGrid: {},
    groupIcon: {
        color: theme.palette.grey[400],
        fontSize: theme.spacing.unit * 3,
    },
    groupIconInfo: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            display: 'inline-block',
        }
    }
});

interface GroupIconGridProps extends WithStyles<typeof styles> {
    groupName: string,
    groupColor: string,
    otherGroups: any[],
}

// return titles for tooltip
const groupTitles = (otherGroups: any[], groupName: string) => {
    let titles = ''
    _.map(otherGroups, ({ name }: any, index: number) => {
        if (!_.isEqual(groupName, name)) {
            titles += name;
            if (index < (otherGroups.length - 1)) {
                titles += ', ';
            }
        }
    });
    return titles;
};

// render group icon grid
const GroupIconGrid = (props: GroupIconGridProps) => {
    const { groupName = '', groupColor = '', otherGroups = [], classes } = props;

    return (
        <div className={classes.groupIconGrid}>
            <div className={classes.groupIcon}>
                {_.isEmpty(otherGroups) ? (
                    <Tooltip title="No group assigned">
                        <UserGroupIcon style={{ height: '24px', width: '24px', fill: 'rgba(0, 0, 0, 0.44)' }} />
                    </Tooltip>
                ) : (
                        <UserGroupIcon style={{ fill: groupColor, height: '24px', width: '24px' }} />
                    )
                }
            </div>
            <div className={classes.groupIconInfo}>
                {!_.isEmpty(groupName) && (
                    <Typography variant="body2"
                        className={classes.groupName}
                        style={{ color: groupColor }}
                    >
                        {groupName}
                    </Typography>
                )}
                {(otherGroups.length > 1) && (
                    <Tooltip title={groupTitles(otherGroups, groupName)}>
                        <Typography variant="body2" color="primary" className={classes.groupName}>,&nbsp;{(otherGroups.length - 1)} more</Typography>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default withStyles(styles)(GroupIconGrid);